import * as r from "react";
import { useRef as at, useEffect as ct, useMemo as ut, isValidElement as dt } from "react";
import { d as Y } from "./warning.js";
import { Q as pt, ab as De, ac as ft, u as mt, g as gt, n as Z, h as yt, E as bt, z as Le, k as W, R as Me, C as vt } from "./CSSMotionList.js";
import { _ as fe } from "./extends.js";
import { I as me } from "./AntdIcon.js";
import { R as Et } from "./index5.js";
import { t as Ae } from "./ContextIsolator.js";
import { u as Ce } from "./useSize.js";
import { o as Pe } from "./omit.js";
import "./index.js";
import { u as ht } from "./useLocale.js";
import { T as ge } from "./index6.js";
import { K as we } from "./KeyCode.js";
import { c as xt } from "./reactNode.js";
import { T as St } from "./TextArea.js";
import { g as Ot } from "./_commonjsHelpers.js";
import { R as Ct } from "./CheckOutlined.js";
import { R as wt } from "./LoadingOutlined.js";
var ke = function(t) {
  if (pt() && window.document.documentElement) {
    var o = Array.isArray(t) ? t : [t], n = window.document.documentElement;
    return o.some(function(s) {
      return s in n.style;
    });
  }
  return !1;
}, Rt = function(t, o) {
  if (!ke(t))
    return !1;
  var n = document.createElement("div"), s = n.style[t];
  return n.style[t] = o, n.style[t] !== s;
};
function Re(e, t) {
  return !Array.isArray(e) && t !== void 0 ? Rt(e, t) : ke(e);
}
const Tt = (e, t = !1) => t && e == null ? [] : Array.isArray(e) ? e : [e];
var _t = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" }, jt = function(t, o) {
  return /* @__PURE__ */ r.createElement(me, fe({}, t, {
    ref: o,
    icon: _t
  }));
}, He = /* @__PURE__ */ r.forwardRef(jt);
process.env.NODE_ENV !== "production" && (He.displayName = "CopyOutlined");
var Nt = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, name: "edit", theme: "outlined" }, It = function(t, o) {
  return /* @__PURE__ */ r.createElement(me, fe({}, t, {
    ref: o,
    icon: Nt
  }));
}, ze = /* @__PURE__ */ r.forwardRef(It);
process.env.NODE_ENV !== "production" && (ze.displayName = "EditOutlined");
var $t = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, name: "enter", theme: "outlined" }, Dt = function(t, o) {
  return /* @__PURE__ */ r.createElement(me, fe({}, t, {
    ref: o,
    icon: $t
  }));
}, Ve = /* @__PURE__ */ r.forwardRef(Dt);
process.env.NODE_ENV !== "production" && (Ve.displayName = "EnterOutlined");
const Lt = (e, t, o, n) => {
  const {
    titleMarginBottom: s,
    fontWeightStrong: i
  } = n;
  return {
    marginBottom: s,
    color: o,
    fontWeight: i,
    fontSize: e,
    lineHeight: t
  };
}, Mt = (e) => {
  const t = [1, 2, 3, 4, 5], o = {};
  return t.forEach((n) => {
    o[`
      h${n}&,
      div&-h${n},
      div&-h${n} > textarea,
      h${n}
    `] = Lt(e[`fontSizeHeading${n}`], e[`lineHeightHeading${n}`], e.colorTextHeading, e);
  }), o;
}, At = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    "a&, a": Object.assign(Object.assign({}, De(e)), {
      userSelect: "text",
      [`&[disabled], &${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:active, &:hover": {
          color: e.colorTextDisabled
        },
        "&:active": {
          pointerEvents: "none"
        }
      }
    })
  };
}, Pt = (e) => ({
  code: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.2em 0.1em",
    fontSize: "85%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3
  },
  kbd: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.15em 0.1em",
    fontSize: "90%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.06)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: ft[2]
  },
  "u, ins": {
    textDecoration: "underline",
    textDecorationSkipInk: "auto"
  },
  "s, del": {
    textDecoration: "line-through"
  },
  strong: {
    fontWeight: 600
  },
  // list
  "ul, ol": {
    marginInline: 0,
    marginBlock: "0 1em",
    padding: 0,
    li: {
      marginInline: "20px 0",
      marginBlock: 0,
      paddingInline: "4px 0",
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: "circle",
    ul: {
      listStyleType: "disc"
    }
  },
  ol: {
    listStyleType: "decimal"
  },
  // pre & block
  "pre, blockquote": {
    margin: "1em 0"
  },
  pre: {
    padding: "0.4em 0.6em",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3,
    fontFamily: e.fontFamilyCode,
    // Compatible for marked
    code: {
      display: "inline",
      margin: 0,
      padding: 0,
      fontSize: "inherit",
      fontFamily: "inherit",
      background: "transparent",
      border: 0
    }
  },
  blockquote: {
    paddingInline: "0.6em 0",
    paddingBlock: 0,
    borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
    opacity: 0.85
  }
}), kt = (e) => {
  const {
    componentCls: t,
    paddingSM: o
  } = e, n = o;
  return {
    "&-edit-content": {
      position: "relative",
      "div&": {
        insetInlineStart: e.calc(e.paddingSM).mul(-1).equal(),
        marginTop: e.calc(n).mul(-1).equal(),
        marginBottom: `calc(1em - ${mt(n)})`
      },
      [`${t}-edit-content-confirm`]: {
        position: "absolute",
        insetInlineEnd: e.calc(e.marginXS).add(2).equal(),
        insetBlockEnd: e.marginXS,
        color: e.colorIcon,
        // default style
        fontWeight: "normal",
        fontSize: e.fontSize,
        fontStyle: "normal",
        pointerEvents: "none"
      },
      textarea: {
        margin: "0!important",
        // Fix Editable Textarea flash in Firefox
        MozTransition: "none",
        height: "1em"
      }
    }
  };
}, Ht = (e) => ({
  [`${e.componentCls}-copy-success`]: {
    "\n    &,\n    &:hover,\n    &:focus": {
      color: e.colorSuccess
    }
  },
  [`${e.componentCls}-copy-icon-only`]: {
    marginInlineStart: 0
  }
}), zt = () => ({
  "\n  a&-ellipsis,\n  span&-ellipsis\n  ": {
    display: "inline-block",
    maxWidth: "100%"
  },
  "&-ellipsis-single-line": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // https://blog.csdn.net/iefreer/article/details/50421025
    "a&, span&": {
      verticalAlign: "bottom"
    },
    "> code": {
      paddingBlock: 0,
      maxWidth: "calc(100% - 1.2em)",
      display: "inline-block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "bottom",
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: "content-box"
    }
  },
  "&-ellipsis-multiple-line": {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  }
}), Vt = (e) => {
  const {
    componentCls: t,
    titleMarginTop: o
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: e.colorText,
      wordBreak: "break-word",
      lineHeight: e.lineHeight,
      [`&${t}-secondary`]: {
        color: e.colorTextDescription
      },
      [`&${t}-success`]: {
        color: e.colorSuccessText
      },
      [`&${t}-warning`]: {
        color: e.colorWarningText
      },
      [`&${t}-danger`]: {
        color: e.colorErrorText,
        "a&:active, a&:focus": {
          color: e.colorErrorTextActive
        },
        "a&:hover": {
          color: e.colorErrorTextHover
        }
      },
      [`&${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
      },
      "\n        div&,\n        p\n      ": {
        marginBottom: "1em"
      }
    }, Mt(e)), {
      [`
      & + h1${t},
      & + h2${t},
      & + h3${t},
      & + h4${t},
      & + h5${t}
      `]: {
        marginTop: o
      },
      "\n      div,\n      ul,\n      li,\n      p,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5": {
        "\n        + h1,\n        + h2,\n        + h3,\n        + h4,\n        + h5\n        ": {
          marginTop: o
        }
      }
    }), Pt(e)), At(e)), {
      // Operation
      [`
        ${t}-expand,
        ${t}-collapse,
        ${t}-edit,
        ${t}-copy
      `]: Object.assign(Object.assign({}, De(e)), {
        marginInlineStart: e.marginXXS
      })
    }), kt(e)), Ht(e)), zt()), {
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
}, Bt = () => ({
  titleMarginTop: "1.2em",
  titleMarginBottom: "0.5em"
}), Be = gt("Typography", (e) => [Vt(e)], Bt), Wt = (e) => {
  const {
    prefixCls: t,
    "aria-label": o,
    className: n,
    style: s,
    direction: i,
    maxLength: p,
    autoSize: u = !0,
    value: c,
    onSave: d,
    onCancel: a,
    onEnd: g,
    component: m,
    enterIcon: C = /* @__PURE__ */ r.createElement(Ve, null)
  } = e, w = r.useRef(null), R = r.useRef(!1), N = r.useRef(null), [y, I] = r.useState(c);
  r.useEffect(() => {
    I(c);
  }, [c]), r.useEffect(() => {
    var b;
    if (!((b = w.current) === null || b === void 0) && b.resizableTextArea) {
      const {
        textArea: h
      } = w.current.resizableTextArea;
      h.focus();
      const {
        length: E
      } = h.value;
      h.setSelectionRange(E, E);
    }
  }, []);
  const k = ({
    target: b
  }) => {
    I(b.value.replace(/[\n\r]/g, ""));
  }, x = () => {
    R.current = !0;
  }, S = () => {
    R.current = !1;
  }, _ = ({
    keyCode: b
  }) => {
    R.current || (N.current = b);
  }, v = () => {
    d(y.trim());
  }, H = ({
    keyCode: b,
    ctrlKey: h,
    altKey: E,
    metaKey: A,
    shiftKey: T
  }) => {
    N.current !== b || R.current || h || E || A || T || (b === we.ENTER ? (v(), g == null || g()) : b === we.ESC && a());
  }, U = () => {
    v();
  }, [B, L, F] = Be(t), M = Z(t, `${t}-edit-content`, {
    [`${t}-rtl`]: i === "rtl",
    [`${t}-${m}`]: !!m
  }, n, L, F);
  return B(/* @__PURE__ */ r.createElement("div", {
    className: M,
    style: s
  }, /* @__PURE__ */ r.createElement(St, {
    ref: w,
    maxLength: p,
    value: y,
    onChange: k,
    onKeyDown: _,
    onKeyUp: H,
    onCompositionStart: x,
    onCompositionEnd: S,
    onBlur: U,
    "aria-label": o,
    rows: 1,
    autoSize: u
  }), C !== null ? xt(C, {
    className: `${t}-edit-content-confirm`
  }) : null));
};
var Ut = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, o = [], n = 0; n < e.rangeCount; n++)
    o.push(e.getRangeAt(n));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || o.forEach(function(s) {
      e.addRange(s);
    }), t && t.focus();
  };
}, Ft = Ut, Te = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, Kt = "Copy to clipboard: #{key}, Enter";
function qt(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function Xt(e, t) {
  var o, n, s, i, p, u, c = !1;
  t || (t = {}), o = t.debug || !1;
  try {
    s = Ft(), i = document.createRange(), p = document.getSelection(), u = document.createElement("span"), u.textContent = e, u.ariaHidden = "true", u.style.all = "unset", u.style.position = "fixed", u.style.top = 0, u.style.clip = "rect(0, 0, 0, 0)", u.style.whiteSpace = "pre", u.style.webkitUserSelect = "text", u.style.MozUserSelect = "text", u.style.msUserSelect = "text", u.style.userSelect = "text", u.addEventListener("copy", function(a) {
      if (a.stopPropagation(), t.format)
        if (a.preventDefault(), typeof a.clipboardData > "u") {
          o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var g = Te[t.format] || Te.default;
          window.clipboardData.setData(g, e);
        } else
          a.clipboardData.clearData(), a.clipboardData.setData(t.format, e);
      t.onCopy && (a.preventDefault(), t.onCopy(a.clipboardData));
    }), document.body.appendChild(u), i.selectNodeContents(u), p.addRange(i);
    var d = document.execCommand("copy");
    if (!d)
      throw new Error("copy command was unsuccessful");
    c = !0;
  } catch (a) {
    o && console.error("unable to copy using execCommand: ", a), o && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), c = !0;
    } catch (g) {
      o && console.error("unable to copy using clipboardData: ", g), o && console.error("falling back to prompt"), n = qt("message" in t ? t.message : Kt), window.prompt(n, e);
    }
  } finally {
    p && (typeof p.removeRange == "function" ? p.removeRange(i) : p.removeAllRanges()), u && document.body.removeChild(u), s();
  }
  return c;
}
var Jt = Xt;
const Qt = /* @__PURE__ */ Ot(Jt);
var Gt = function(e, t, o, n) {
  function s(i) {
    return i instanceof o ? i : new o(function(p) {
      p(i);
    });
  }
  return new (o || (o = Promise))(function(i, p) {
    function u(a) {
      try {
        d(n.next(a));
      } catch (g) {
        p(g);
      }
    }
    function c(a) {
      try {
        d(n.throw(a));
      } catch (g) {
        p(g);
      }
    }
    function d(a) {
      a.done ? i(a.value) : s(a.value).then(u, c);
    }
    d((n = n.apply(e, t || [])).next());
  });
};
const Yt = ({
  copyConfig: e,
  children: t
}) => {
  const [o, n] = r.useState(!1), [s, i] = r.useState(!1), p = r.useRef(null), u = () => {
    p.current && clearTimeout(p.current);
  }, c = {};
  e.format && (c.format = e.format), r.useEffect(() => u, []);
  const d = yt((a) => Gt(void 0, void 0, void 0, function* () {
    var g;
    a == null || a.preventDefault(), a == null || a.stopPropagation(), i(!0);
    try {
      const m = typeof e.text == "function" ? yield e.text() : e.text;
      Qt(m || Tt(t, !0).join("") || "", c), i(!1), n(!0), u(), p.current = setTimeout(() => {
        n(!1);
      }, 3e3), (g = e.onCopy) === null || g === void 0 || g.call(e, a);
    } catch (m) {
      throw i(!1), m;
    }
  }));
  return {
    copied: o,
    copyLoading: s,
    onClick: d
  };
};
function le(e, t) {
  return r.useMemo(() => {
    const o = !!e;
    return [o, Object.assign(Object.assign({}, t), o && typeof e == "object" ? e : null)];
  }, [e]);
}
const Zt = (e) => {
  const t = at(void 0);
  return ct(() => {
    t.current = e;
  }), t.current;
}, en = (e, t, o) => ut(() => e === !0 ? {
  title: t ?? o
} : /* @__PURE__ */ dt(e) ? {
  title: e
} : typeof e == "object" ? Object.assign({
  title: t ?? o
}, e) : {
  title: e
}, [e, t, o]);
var tn = function(e, t) {
  var o = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var s = 0, n = Object.getOwnPropertySymbols(e); s < n.length; s++)
    t.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[s]) && (o[n[s]] = e[n[s]]);
  return o;
};
const ye = /* @__PURE__ */ r.forwardRef((e, t) => {
  const {
    prefixCls: o,
    component: n = "article",
    className: s,
    rootClassName: i,
    setContentRef: p,
    children: u,
    direction: c,
    style: d
  } = e, a = tn(e, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]), {
    getPrefixCls: g,
    direction: m,
    className: C,
    style: w
  } = bt("typography"), R = c ?? m, N = p ? Le(t, p) : t, y = g("typography", o);
  process.env.NODE_ENV !== "production" && Y("Typography").deprecated(!p, "setContentRef", "ref");
  const [I, k, x] = Be(y), S = Z(y, C, {
    [`${y}-rtl`]: R === "rtl"
  }, s, i, k, x), _ = Object.assign(Object.assign({}, w), d);
  return I(
    // @ts-expect-error: Expression produces a union type that is too complex to represent.
    /* @__PURE__ */ r.createElement(n, Object.assign({
      className: S,
      style: _,
      ref: N
    }, a), u)
  );
});
process.env.NODE_ENV !== "production" && (ye.displayName = "Typography");
function _e(e) {
  return e === !1 ? [!1, !1] : Array.isArray(e) ? e : [e];
}
function ae(e, t, o) {
  return e === !0 || e === void 0 ? t : e || o && t;
}
function nn(e) {
  const t = document.createElement("em");
  e.appendChild(t), process.env.NODE_ENV !== "production" && (t.className = "ant-typography-css-ellipsis-content-measure");
  const o = e.getBoundingClientRect(), n = t.getBoundingClientRect();
  return e.removeChild(t), // Horizontal out of range
  o.left > n.left || n.right > o.right || // Vertical out of range
  o.top > n.top || n.bottom > o.bottom;
}
const be = (e) => ["string", "number"].includes(typeof e), on = ({
  prefixCls: e,
  copied: t,
  locale: o,
  iconOnly: n,
  tooltips: s,
  icon: i,
  tabIndex: p,
  onCopy: u,
  loading: c
}) => {
  const d = _e(s), a = _e(i), {
    copied: g,
    copy: m
  } = o ?? {}, C = t ? g : m, w = ae(d[t ? 1 : 0], C), R = typeof w == "string" ? w : C;
  return /* @__PURE__ */ r.createElement(ge, {
    title: w
  }, /* @__PURE__ */ r.createElement("button", {
    type: "button",
    className: Z(`${e}-copy`, {
      [`${e}-copy-success`]: t,
      [`${e}-copy-icon-only`]: n
    }),
    onClick: u,
    "aria-label": R,
    tabIndex: p
  }, t ? ae(a[1], /* @__PURE__ */ r.createElement(Ct, null), !0) : ae(a[0], c ? /* @__PURE__ */ r.createElement(wt, null) : /* @__PURE__ */ r.createElement(He, null), !0)));
}, Q = /* @__PURE__ */ r.forwardRef(({
  style: e,
  children: t
}, o) => {
  const n = r.useRef(null);
  return r.useImperativeHandle(o, () => ({
    isExceed: () => {
      const s = n.current;
      return s.scrollHeight > s.clientHeight;
    },
    getHeight: () => n.current.clientHeight
  })), /* @__PURE__ */ r.createElement("span", {
    "aria-hidden": !0,
    ref: n,
    style: Object.assign({
      position: "fixed",
      display: "block",
      left: 0,
      top: 0,
      pointerEvents: "none",
      backgroundColor: "rgba(255, 0, 0, 0.65)"
    }, e)
  }, t);
}), rn = (e) => e.reduce((t, o) => t + (be(o) ? String(o).length : 1), 0);
function je(e, t) {
  let o = 0;
  const n = [];
  for (let s = 0; s < e.length; s += 1) {
    if (o === t)
      return n;
    const i = e[s], u = be(i) ? String(i).length : 1, c = o + u;
    if (c > t) {
      const d = t - o;
      return n.push(String(i).slice(0, d)), n;
    }
    n.push(i), o = c;
  }
  return e;
}
const ce = 0, ue = 1, de = 2, pe = 3, Ne = 4, G = {
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical"
};
function sn(e) {
  const {
    enableMeasure: t,
    width: o,
    text: n,
    children: s,
    rows: i,
    expanded: p,
    miscDeps: u,
    onEllipsis: c
  } = e, d = r.useMemo(() => Ae(n), [n]), a = r.useMemo(() => rn(d), [n]), g = r.useMemo(() => s(d, !1), [n]), [m, C] = r.useState(null), w = r.useRef(null), R = r.useRef(null), N = r.useRef(null), y = r.useRef(null), I = r.useRef(null), [k, x] = r.useState(!1), [S, _] = r.useState(ce), [v, H] = r.useState(0), [U, B] = r.useState(null);
  W(() => {
    _(t && o && a ? ue : ce);
  }, [o, n, i, t, d]), W(() => {
    var b, h, E, A;
    if (S === ue) {
      _(de);
      const T = R.current && getComputedStyle(R.current).whiteSpace;
      B(T);
    } else if (S === de) {
      const T = !!(!((b = N.current) === null || b === void 0) && b.isExceed());
      _(T ? pe : Ne), C(T ? [0, a] : null), x(T);
      const z = ((h = N.current) === null || h === void 0 ? void 0 : h.getHeight()) || 0, ne = i === 1 ? 0 : ((E = y.current) === null || E === void 0 ? void 0 : E.getHeight()) || 0, q = ((A = I.current) === null || A === void 0 ? void 0 : A.getHeight()) || 0, oe = Math.max(
        z,
        // height of rows with ellipsis
        ne + q
      );
      H(oe + 1), c(T);
    }
  }, [S]);
  const L = m ? Math.ceil((m[0] + m[1]) / 2) : 0;
  W(() => {
    var b;
    const [h, E] = m || [0, 0];
    if (h !== E) {
      const T = (((b = w.current) === null || b === void 0 ? void 0 : b.getHeight()) || 0) > v;
      let z = L;
      E - h === 1 && (z = T ? h : E), C(T ? [h, z] : [z, E]);
    }
  }, [m, L]);
  const F = r.useMemo(() => {
    if (!t)
      return s(d, !1);
    if (S !== pe || !m || m[0] !== m[1]) {
      const b = s(d, !1);
      return [Ne, ce].includes(S) ? b : /* @__PURE__ */ r.createElement("span", {
        style: Object.assign(Object.assign({}, G), {
          WebkitLineClamp: i
        })
      }, b);
    }
    return s(p ? d : je(d, m[0]), k);
  }, [p, S, m, d].concat(Me(u))), M = {
    width: o,
    margin: 0,
    padding: 0,
    whiteSpace: U === "nowrap" ? "normal" : "inherit"
  };
  return /* @__PURE__ */ r.createElement(r.Fragment, null, F, S === de && /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(Q, {
    style: Object.assign(Object.assign(Object.assign({}, M), G), {
      WebkitLineClamp: i
    }),
    ref: N
  }, g), /* @__PURE__ */ r.createElement(Q, {
    style: Object.assign(Object.assign(Object.assign({}, M), G), {
      WebkitLineClamp: i - 1
    }),
    ref: y
  }, g), /* @__PURE__ */ r.createElement(Q, {
    style: Object.assign(Object.assign(Object.assign({}, M), G), {
      WebkitLineClamp: 1
    }),
    ref: I
  }, s([], !0))), S === pe && m && m[0] !== m[1] && /* @__PURE__ */ r.createElement(Q, {
    style: Object.assign(Object.assign({}, M), {
      top: 400
    }),
    ref: w
  }, s(je(d, L), !0)), S === ue && /* @__PURE__ */ r.createElement("span", {
    style: {
      whiteSpace: "inherit"
    },
    ref: R
  }));
}
const We = ({
  enableEllipsis: e,
  isEllipsis: t,
  children: o,
  tooltipProps: n
}) => !(n != null && n.title) || !e ? o : /* @__PURE__ */ r.createElement(ge, Object.assign({
  open: t ? void 0 : !1
}, n), o);
process.env.NODE_ENV !== "production" && (We.displayName = "EllipsisTooltip");
var ln = function(e, t) {
  var o = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var s = 0, n = Object.getOwnPropertySymbols(e); s < n.length; s++)
    t.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[s]) && (o[n[s]] = e[n[s]]);
  return o;
};
function an({
  mark: e,
  code: t,
  underline: o,
  delete: n,
  strong: s,
  keyboard: i,
  italic: p
}, u) {
  let c = u;
  function d(a, g) {
    g && (c = /* @__PURE__ */ r.createElement(a, {}, c));
  }
  return d("strong", s), d("u", o), d("del", n), d("code", t), d("mark", e), d("kbd", i), d("i", p), c;
}
const cn = "...", Ie = ["delete", "mark", "code", "underline", "strong", "keyboard", "italic"], ee = /* @__PURE__ */ r.forwardRef((e, t) => {
  var o;
  const {
    prefixCls: n,
    className: s,
    style: i,
    type: p,
    disabled: u,
    children: c,
    ellipsis: d,
    editable: a,
    copyable: g,
    component: m,
    title: C
  } = e, w = ln(e, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]), {
    getPrefixCls: R,
    direction: N
  } = r.useContext(vt), [y] = ht("Text"), I = r.useRef(null), k = r.useRef(null), x = R("typography", n), S = Pe(w, Ie), [_, v] = le(a), [H, U] = Ce(!1, {
    value: v.editing
  }), {
    triggerType: B = ["icon"]
  } = v, L = (l) => {
    var f;
    l && ((f = v.onStart) === null || f === void 0 || f.call(v)), U(l);
  }, F = Zt(H);
  W(() => {
    var l;
    !H && F && ((l = k.current) === null || l === void 0 || l.focus());
  }, [H]);
  const M = (l) => {
    l == null || l.preventDefault(), L(!0);
  }, b = (l) => {
    var f;
    (f = v.onChange) === null || f === void 0 || f.call(v, l), L(!1);
  }, h = () => {
    var l;
    (l = v.onCancel) === null || l === void 0 || l.call(v), L(!1);
  }, [E, A] = le(g), {
    copied: T,
    copyLoading: z,
    onClick: ne
  } = Yt({
    copyConfig: A,
    children: c
  }), [q, oe] = r.useState(!1), [ve, Ue] = r.useState(!1), [Ee, Fe] = r.useState(!1), [he, Ke] = r.useState(!1), [qe, Xe] = r.useState(!0), [V, O] = le(d, {
    expandable: !1,
    symbol: (l) => l ? y == null ? void 0 : y.collapse : y == null ? void 0 : y.expand
  }), [P, Je] = Ce(O.defaultExpanded || !1, {
    value: O.expanded
  }), j = V && (!P || O.expandable === "collapsible"), {
    rows: K = 1
  } = O, X = r.useMemo(() => (
    // Disable ellipsis
    j && // Provide suffix
    (O.suffix !== void 0 || O.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
    O.expandable || _ || E)
  ), [j, O, _, E]);
  W(() => {
    V && !X && (oe(Re("webkitLineClamp")), Ue(Re("textOverflow")));
  }, [X, V]);
  const [$, Qe] = r.useState(j), xe = r.useMemo(() => X ? !1 : K === 1 ? ve : q, [X, ve, q]);
  W(() => {
    Qe(xe && j);
  }, [xe, j]);
  const Se = j && ($ ? he : Ee), Ge = j && K === 1 && $, re = j && K > 1 && $, Ye = (l, f) => {
    var D;
    Je(f.expanded), (D = O.onExpand) === null || D === void 0 || D.call(O, l, f);
  }, [Oe, Ze] = r.useState(0), et = ({
    offsetWidth: l
  }) => {
    Ze(l);
  }, tt = (l) => {
    var f;
    Fe(l), Ee !== l && ((f = O.onEllipsis) === null || f === void 0 || f.call(O, l));
  };
  r.useEffect(() => {
    const l = I.current;
    if (V && $ && l) {
      const f = nn(l);
      he !== f && Ke(f);
    }
  }, [V, $, c, re, qe, Oe]), r.useEffect(() => {
    const l = I.current;
    if (typeof IntersectionObserver > "u" || !l || !$ || !j)
      return;
    const f = new IntersectionObserver(() => {
      Xe(!!l.offsetParent);
    });
    return f.observe(l), () => {
      f.disconnect();
    };
  }, [$, j]);
  const se = en(O.tooltip, v.text, c), J = r.useMemo(() => {
    if (!(!V || $))
      return [v.text, c, C, se.title].find(be);
  }, [V, $, C, se.title, Se]);
  if (H)
    return /* @__PURE__ */ r.createElement(Wt, {
      value: (o = v.text) !== null && o !== void 0 ? o : typeof c == "string" ? c : "",
      onSave: b,
      onCancel: h,
      onEnd: v.onEnd,
      prefixCls: x,
      className: s,
      style: i,
      direction: N,
      component: m,
      maxLength: v.maxLength,
      autoSize: v.autoSize,
      enterIcon: v.enterIcon
    });
  const nt = () => {
    const {
      expandable: l,
      symbol: f
    } = O;
    return l ? /* @__PURE__ */ r.createElement("button", {
      type: "button",
      key: "expand",
      className: `${x}-${P ? "collapse" : "expand"}`,
      onClick: (D) => Ye(D, {
        expanded: !P
      }),
      "aria-label": P ? y.collapse : y == null ? void 0 : y.expand
    }, typeof f == "function" ? f(P) : f) : null;
  }, ot = () => {
    if (!_)
      return;
    const {
      icon: l,
      tooltip: f,
      tabIndex: D
    } = v, ie = Ae(f)[0] || (y == null ? void 0 : y.edit), lt = typeof ie == "string" ? ie : "";
    return B.includes("icon") ? /* @__PURE__ */ r.createElement(ge, {
      key: "edit",
      title: f === !1 ? "" : ie
    }, /* @__PURE__ */ r.createElement("button", {
      type: "button",
      ref: k,
      className: `${x}-edit`,
      onClick: M,
      "aria-label": lt,
      tabIndex: D
    }, l || /* @__PURE__ */ r.createElement(ze, {
      role: "button"
    }))) : null;
  }, rt = () => E ? /* @__PURE__ */ r.createElement(on, Object.assign({
    key: "copy"
  }, A, {
    prefixCls: x,
    copied: T,
    locale: y,
    onCopy: ne,
    loading: z,
    iconOnly: c == null
  })) : null, st = (l) => [l && nt(), ot(), rt()], it = (l) => [l && !P && /* @__PURE__ */ r.createElement("span", {
    "aria-hidden": !0,
    key: "ellipsis"
  }, cn), O.suffix, st(l)];
  return /* @__PURE__ */ r.createElement(Et, {
    onResize: et,
    disabled: !j
  }, (l) => /* @__PURE__ */ r.createElement(We, {
    tooltipProps: se,
    enableEllipsis: j,
    isEllipsis: Se
  }, /* @__PURE__ */ r.createElement(ye, Object.assign({
    className: Z({
      [`${x}-${p}`]: p,
      [`${x}-disabled`]: u,
      [`${x}-ellipsis`]: V,
      [`${x}-ellipsis-single-line`]: Ge,
      [`${x}-ellipsis-multiple-line`]: re
    }, s),
    prefixCls: n,
    style: Object.assign(Object.assign({}, i), {
      WebkitLineClamp: re ? K : void 0
    }),
    component: m,
    ref: Le(l, I, t),
    direction: N,
    onClick: B.includes("text") ? M : void 0,
    "aria-label": J == null ? void 0 : J.toString(),
    title: C
  }, S), /* @__PURE__ */ r.createElement(sn, {
    enableMeasure: j && !$,
    text: c,
    rows: K,
    width: Oe,
    onEllipsis: tt,
    expanded: P,
    miscDeps: [T, P, z, _, E, y].concat(Me(Ie.map((f) => e[f])))
  }, (f, D) => an(e, /* @__PURE__ */ r.createElement(r.Fragment, null, f.length > 0 && D && !P && J ? /* @__PURE__ */ r.createElement("span", {
    key: "show-content",
    "aria-hidden": !0
  }, f) : f, it(D)))))));
});
var un = function(e, t) {
  var o = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var s = 0, n = Object.getOwnPropertySymbols(e); s < n.length; s++)
    t.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[s]) && (o[n[s]] = e[n[s]]);
  return o;
};
const dn = /* @__PURE__ */ r.forwardRef((e, t) => {
  var {
    ellipsis: o,
    rel: n
  } = e, s = un(e, ["ellipsis", "rel"]);
  if (process.env.NODE_ENV !== "production") {
    const p = Y("Typography.Link");
    process.env.NODE_ENV !== "production" && p(typeof o != "object", "usage", "`ellipsis` only supports boolean value.");
  }
  const i = Object.assign(Object.assign({}, s), {
    rel: n === void 0 && s.target === "_blank" ? "noopener noreferrer" : n
  });
  return delete i.navigate, /* @__PURE__ */ r.createElement(ee, Object.assign({}, i, {
    ref: t,
    ellipsis: !!o,
    component: "a"
  }));
}), pn = /* @__PURE__ */ r.forwardRef((e, t) => /* @__PURE__ */ r.createElement(ee, Object.assign({
  ref: t
}, e, {
  component: "div"
})));
var fn = function(e, t) {
  var o = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var s = 0, n = Object.getOwnPropertySymbols(e); s < n.length; s++)
    t.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[s]) && (o[n[s]] = e[n[s]]);
  return o;
};
const mn = (e, t) => {
  var {
    ellipsis: o
  } = e, n = fn(e, ["ellipsis"]);
  const s = r.useMemo(() => o && typeof o == "object" ? Pe(o, ["expandable", "rows"]) : o, [o]);
  if (process.env.NODE_ENV !== "production") {
    const i = Y("Typography.Text");
    process.env.NODE_ENV !== "production" && i(typeof o != "object" || !o || !("expandable" in o) && !("rows" in o), "usage", "`ellipsis` do not support `expandable` or `rows` props.");
  }
  return /* @__PURE__ */ r.createElement(ee, Object.assign({
    ref: t
  }, n, {
    ellipsis: s,
    component: "span"
  }));
}, gn = /* @__PURE__ */ r.forwardRef(mn);
var yn = function(e, t) {
  var o = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var s = 0, n = Object.getOwnPropertySymbols(e); s < n.length; s++)
    t.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[s]) && (o[n[s]] = e[n[s]]);
  return o;
};
const $e = [1, 2, 3, 4, 5], bn = /* @__PURE__ */ r.forwardRef((e, t) => {
  const {
    level: o = 1
  } = e, n = yn(e, ["level"]);
  if (process.env.NODE_ENV !== "production") {
    const i = Y("Typography.Title");
    process.env.NODE_ENV !== "production" && i($e.includes(o), "usage", "Title only accept `1 | 2 | 3 | 4 | 5` as `level` value. And `5` need 4.6.0+ version.");
  }
  const s = $e.includes(o) ? `h${o}` : "h1";
  return /* @__PURE__ */ r.createElement(ee, Object.assign({
    ref: t
  }, n, {
    component: s
  }));
}), te = ye;
te.Text = gn;
te.Link = dn;
te.Title = bn;
te.Paragraph = pn;
export {
  te as T,
  Re as i
};
